import React, { useEffect, useState } from "react";
// SM-AUTH-HR: use the shared client so every call sends the login token.
// REVERT: change back to  import axios from "axios";  and remove authHeader
// from the import and from the export fetch below.
import axios, { authHeader } from "./axios";
import Icon from "./ui/Icon";
import EmptyState from "./ui/EmptyState";
import useCountUp from "./ui/useCountUp";
import "../styles/skillHome.css";
import "../styles/BenchReport.css";

export default function BenchReport() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [summary, setSummary] = useState({
        total: 0,
        shortTerm: 0,
        longTerm: 0,
    });

    useEffect(() => {
        fetchBenchData();
    }, []);

    const fetchBenchData = async () => {
        try {
            const res = await axios.get("/api/BenchReport/active-resources");

            const result = res.data || [];
            setData(result);

            // Summary
            const total = result.length;

            const shortTerm = result.filter(
                x => (x.benchDays ?? 0) <= 30
            ).length;

            const longTerm = result.filter(
                x => (x.benchDays ?? 0) > 30
            ).length;

            setSummary({
                total,
                shortTerm,
                longTerm,
            });

        } catch (error) {
            //if (process.env.NODE_ENV !== "production") {
            //    console.error("Error fetching bench report:", error);
            //}
        } finally {
            setLoading(false);
        }
    };

    // =========================
    // EXPORT TO EXCEL
    // =========================
    const exportToExcel = async () => {
        try {
            const formattedData = data.map(emp => ({
                employeeId: emp.employeeId,
                employeeName: emp.employeeName,
                reportingManager: emp.reportingManager,
                doj: emp.doj,
                mobileNumber: emp.mobileNumber,
                primarySkills: emp.primarySkills,
                secondarySkills: emp.secondarySkills,
                totalExperience: emp.totalExperience,
                benchStartDate: emp.benchStartDate,
                benchDays: emp.benchDays,
                benchNotStarted: emp.benchNotStarted
            }));

            const response = await fetch(
                "/api/BenchReport/download-bench-report",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        // SM-AUTH-HR: send the login token. REVERT: delete this line.
                        ...authHeader()
                    },
                    body: JSON.stringify(formattedData)
                }
            );

            if (!response.ok) {
                throw new Error("Download failed");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = "Bench_Report.xlsx";

            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);

        } catch (err) {
            //if (process.env.NODE_ENV !== "production") {
            //    console.error("Error downloading bench report:", err);
            //}

            //alert("Download failed");
        }
    };

    const animatedTotal = useCountUp(summary.total);
    const animatedShort = useCountUp(summary.shortTerm);
    const animatedLong = useCountUp(summary.longTerm);

    return (
        <div className="skill-home-wrapper">
            <header className="page-head reveal">
                <span className="page-eyebrow">Reports</span>
                <h1 className="page-title-mt">Bench Report</h1>
                <p className="page-sub">View employees currently on bench.</p>
            </header>

            {/* SUMMARY */}
            <div className="kpi-grid team-kpi-grid">
                <div className="card-mt card-pad kpi-card reveal reveal-d1">
                    <div className="kpi-icon"><Icon name="briefcase" size={19} /></div>
                    <div className="kpi-body">
                        <h6 className="kpi-label">Total Bench</h6>
                        <h3 className="kpi-value num">{animatedTotal}</h3>
                    </div>
                </div>

                <div className="card-mt card-pad kpi-card reveal reveal-d2">
                    <div className="kpi-icon"><Icon name="clock" size={19} /></div>
                    <div className="kpi-body">
                        <h6 className="kpi-label">0–30 Days</h6>
                        <h3 className="kpi-value num">{animatedShort}</h3>
                    </div>
                </div>

                <div className="card-mt card-pad kpi-card reveal reveal-d3">
                    <div className="kpi-icon kpi-icon-gold"><Icon name="alertCircle" size={19} /></div>
                    <div className="kpi-body">
                        <h6 className="kpi-label">30+ Days</h6>
                        <h3 className="kpi-value num">{animatedLong}</h3>
                    </div>
                </div>
            </div>

            {/* EMPLOYEE LIST */}
            <section className="card-mt reveal reveal-d3">
                <div className="bench-toolbar">
                    <h5 className="card-title-mt bench-toolbar-title">
                        <span className="card-title-icon"><Icon name="users" size={16} /></span>
                        Employee List
                    </h5>

                    <button
                        onClick={exportToExcel}
                        className="btn btn-primary-mt"
                        disabled={!data.length}
                    >
                        <Icon name="download" size={16} />
                        Export to Excel
                    </button>
                </div>

                <div className="table-wrap">
                    <table className="table-mt bench-table">
                        <thead>
                            <tr>
                                <th scope="col">Emp ID</th>
                                <th scope="col">Employee Name</th>
                                <th scope="col">Reporting Manager</th>
                                <th scope="col">DOJ</th>
                                <th scope="col">Mobile Number</th>
                                <th scope="col">Primary Skills</th>
                                <th scope="col">Secondary Skills</th>
                                <th scope="col">Total Experience</th>
                                <th scope="col">Bench Start Date</th>
                                <th scope="col">Bench Days</th>
                            </tr>
                        </thead>

                        <tbody>
                            {loading ? (
                                [1, 2, 3, 4, 5].map(i => (
                                    <tr key={i}>
                                        <td colSpan="10"><div className="skeleton" style={{ height: 20 }} /></td>
                                    </tr>
                                ))
                            ) : data.length > 0 ? (
                                data.map((emp) => (
                                    <tr key={emp.employeeId}>
                                        <td className="num">{emp.employeeId}</td>
                                        <td className="bench-emp-name">{emp.employeeName}</td>
                                        <td>{emp.reportingManager || "—"}</td>
                                        <td className="num">
                                            {emp.doj
                                                ? new Date(emp.doj).toLocaleDateString()
                                                : "—"}
                                        </td>
                                        <td className="num">{emp.mobileNumber || "—"}</td>
                                        <td className="bench-skills-cell">{emp.primarySkills || "—"}</td>
                                        <td className="bench-skills-cell">{emp.secondarySkills || "—"}</td>
                                        <td className="num">{emp.totalExperience}</td>
                                        <td className="num">
                                            {emp.benchStartDate
                                                ? new Date(emp.benchStartDate).toLocaleDateString()
                                                : "—"}
                                        </td>
                                        <td>
                                            {/* SM-DV-014: a bench start date in the future
                                                used to render a negative day count. It now
                                                reads as "Not started" — 0 days so far. */}
                                            {emp.benchNotStarted ? (
                                                <span
                                                    className="badge-mt"
                                                    title={`Bench starts ${new Date(emp.benchStartDate).toLocaleDateString()}`}
                                                >
                                                    Not started
                                                </span>
                                            ) : (
                                                <span
                                                    className={`badge-mt num ${(emp.benchDays ?? 0) > 30
                                                        ? "badge-danger"
                                                        : "badge-success"
                                                        }`}
                                                >
                                                    {emp.benchDays ?? "—"}
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10">
                                        <EmptyState
                                            icon="briefcase"
                                            title="No one on bench"
                                            text="There are currently no employees on the bench."
                                        />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    );
}
